import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import history from "../helpers/history";
import { config } from "../config/config";
import c, { PASSWORD_REGEX } from "../helpers/constants";
import { didFetchingCustomerFailed } from "../selectors/Customer";
import "../styles/Login.scss";
import Button from "../components/Button";
import TextInput from "../components/TextInput";
import { getCustomer } from "../selectors/Customer";

import Alert from "../components/Alert/Alert";

import { useParams } from "react-router-dom";
import { completePasswordReset } from "../api/EmailApi";
import { setCustomerID, useQuery } from "../helpers/functions";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const query = useQuery();

  const [customerId, setCustomerId] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confpassword, setConfPassword] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [clickedOnce, setClickedOnce] = useState(false);
  const fetchingFailed = useSelector(didFetchingCustomerFailed);
  const customer = useSelector(getCustomer);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [passwordUpdated, setPasswordUpdated] = useState<boolean>(false);
  const [passwordUpdatedFailed, setPasswordUpdatedFailed] =
    useState<boolean>(false);
  const imgs = config.loginPage.images;
  const [imgIndex, setImgIndex] = useState(0);

  useEffect(() => {
    const t = query.get("token") || "";
    const c = query.get("customerId") || "";
    const e = query.get("email") || "";
    setCustomerId(c);
    setEmail(e);
    setToken(t);

    if (!t || !c || !e) {
      setAlertMessage(
        "Invalid reset link. Please request a new password reset link."
      );
      setShowAlert(true);
    }
  }, []);

  const setStrokeData = () => {
    const radius = 26;
    let angle = ((imgIndex + 1) / imgs.length) * 360;
    const circumference = 2 * Math.PI * radius;
    const strokeDasharray = (angle / 360) * circumference;
    const strokeOffset = ((imgIndex + 1) / imgs.length) * circumference;
    let dash = [strokeDasharray, circumference - strokeDasharray];
    return [dash, strokeOffset + "px"];
  };

  let strokeData = setStrokeData();
  const strokeDasharray = strokeData[0];
  const dashOffset = strokeData[1];

  const onChangePassword = async () => {
    if (!customerId || !token) {
      setAlertMessage(
        "Invalid reset link. Please request a new password reset link."
      );
      setShowAlert(true);
      return;
    }

    setIsLoading(true);
    setClickedOnce(true);

    if (password !== confpassword) {
      setAlertMessage("Passwords do not match");
      setShowAlert(true);
      setIsLoading(false);
      return;
    }

    if (!PASSWORD_REGEX.test(password)) {
      setAlertMessage(
        "Your password must be at least 6 characters and contain one uppercase letter, number or special character"
      );
      setShowAlert(true);
      setIsLoading(false);
      return;
    }

    const data = {
      customerId: customerId,
      newPassword: password,
      token: token,
      email: email,
    };

    const result = await completePasswordReset(data);

    if (result?.data?.return_code === "OK") {
      setPasswordUpdated(true);
    } else {
      setPasswordUpdatedFailed(true);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (!fetchingFailed && customer !== null) {
      history.push(c.APP_ROUTES.DASHBOARD);
    }
  }, [customer]);

  const isFormReady =
    email?.length > 0 &&
    password?.length > 0 &&
    confpassword?.length > 0 &&
    customerId?.length > 0 &&
    token?.length > 0;

  console.log(customerId, token, password, confpassword);
  return (
    <div>
      <div className="page-container login-outer">
        <div className="row">
          <div className="col-lg-6">
            <div className="login-container">
              <img alt="Likewise Logo" src={config.likewiseLogo} />
              <h3 className="mt-4">Reset Your Password</h3>

              <div className="mb-3 mt-2 input-container">
                <TextInput
                  label="New Password*"
                  bgColor="grey"
                  id="password"
                  name="password"
                  value={password}
                  onBlur={(e) => setPassword(e)}
                  style="normal"
                  type="password"
                  onChange={(e) => setPassword(e)}
                  placeholder="Enter your password here"
                />
              </div>
              <div className="mb-3 mt-2 input-container">
                <TextInput
                  label="Confirm Password*"
                  bgColor="grey"
                  id="postcode"
                  name="confpassword"
                  value={confpassword}
                  onBlur={(e) => setConfPassword(e)}
                  style="normal"
                  type="password"
                  onChange={(e) => setConfPassword(e)}
                  placeholder="Enter your password here"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onChangePassword();
                    }
                  }}
                />
              </div>

              {showAlert && (
                <div className="mt-4 mb-4 error-message-alert">
                  <p>{alertMessage}</p>
                </div>
              )}

              {fetchingFailed &&
                customerId &&
                password &&
                confpassword &&
                clickedOnce && (
                  <div className="mt-4 mb-4 error-message-alert">
                    <svg
                      width="26px"
                      height="26px"
                      viewBox="0 0 26 26"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        id="Phase-4---UI-Design-Amendments"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                        opacity="1"
                      >
                        <g
                          id="Individual-Product-Page-1"
                          transform="translate(-1534.000000, -778.000000)"
                          fill="#C84645"
                          fill-rule="nonzero"
                        >
                          <g
                            id="add"
                            transform="translate(1547.000000, 791.000000) rotate(-315.000000) translate(-1547.000000, -791.000000) translate(1538.000000, 782.000000)"
                          >
                            <path
                              d="M16.3928571,7.39285714 L10.9285714,7.39285714 C10.7510637,7.39285714 10.6071429,7.24893625 10.6071429,7.07142857 L10.6071429,1.60714286 C10.6071429,0.719604482 9.88753838,0 9,0 C8.11246162,0 7.39285714,0.719604482 7.39285714,1.60714286 L7.39285714,7.07142857 C7.39285714,7.24893625 7.24893625,7.39285714 7.07142857,7.39285714 L1.60714286,7.39285714 C0.719604482,7.39285714 0,8.11246162 0,9 C0,9.88753838 0.719604482,10.6071429 1.60714286,10.6071429 L7.07142857,10.6071429 C7.24893625,10.6071429 7.39285714,10.7510637 7.39285714,10.9285714 L7.39285714,16.3928571 C7.39285714,17.2803955 8.11246162,18 9,18 C9.88753838,18 10.6071429,17.2803955 10.6071429,16.3928571 L10.6071429,10.9285714 C10.6071429,10.7510637 10.7510637,10.6071429 10.9285714,10.6071429 L16.3928571,10.6071429 C17.2803955,10.6071429 18,9.88753838 18,9 C18,8.11246162 17.2803955,7.39285714 16.3928571,7.39285714 Z"
                              id="Path"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                    Wrong customer number or password
                  </div>
                )}

              <div className="mt-3 input-container submit-button">
                <Button
                  disabled={isLoading || !isFormReady}
                  onClick={onChangePassword}
                  size="stretch"
                  text={isLoading ? "Loading..." : "Change Password"}
                />
              </div>

              <div className="footer-bottom__copyright text-grey text-left">
                <p>
                  © {new Date().getFullYear()} {config.copyrightText} Designed
                  and Powered by{" "}
                  <a
                    href="https://www.sketchcreative.co/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Sketch Creative
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 login-img-column">
            <div
              className="img-rotator"
              style={{
                backgroundImage: `url("${config.loginPage.images[imgIndex]}")`,
              }}
            >
              <div className="rotator-inner">
                <div className="graph">
                  <svg>
                    <circle
                      cx="30"
                      cy="30"
                      r="26"
                      stroke-dasharray={strokeDasharray}
                      stroke-dashoffset={dashOffset}
                    />
                  </svg>
                  <span className="graph-counter">
                    <span>{imgIndex + 1}/</span>
                    <span>{imgs.length}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {passwordUpdated && (
        <Alert
          title="Password Updated"
          message="Your password has been updated successfully"
          showOkButton={true}
          showCancelButton={false}
          onOk={() => {
            setShowAlert(false);
            history.push(c.APP_ROUTES.DASHBOARD);
          }}
        />
      )}

      {passwordUpdatedFailed && (
        <Alert
          title="Password Update Failed"
          message="There was an error updating your password, please try again"
          showOkButton={true}
          showCancelButton={false}
          onOk={() => {
            setPasswordUpdatedFailed(false);
          }}
        />
      )}
    </div>
  );
};

export default ResetPassword;
